export default __webpack_public_path__ + "static/media/icon-caret-down.cadce649.svg";